/**
 * This file is created manually
 * You can change the content
 *
 */

import H6 from './typography/H6'
export * from './typography/H6'
export default H6
